export default __webpack_public_path__ + "static/thumb-landscape-94c94687470aaf85c6270ad0dbdab87b.jpg";